export default __webpack_public_path__ + "static/media/7minfitness_8@3x.d77639ee.jpg";